import { createAsyncAction } from 'typesafe-actions';
import { Option, RoleOption } from './types';

export const getRolesAsync = createAsyncAction(
  'content/GET_ROLES_REQUEST',
  'content/GET_ROLES_SUCCESS',
  'content/GET_ROLES_FAILURE',
)<void, RoleOption[], Error>();

export const getTradesAsync = createAsyncAction(
  'content/GET_TRADES_REQUEST',
  'content/GET_TRADES_SUCCESS',
  'content/GET_TRADES_FAILURE',
)<void, Option[], Error>();

export const getLevelsAsync = createAsyncAction(
  'content/GET_LEVELS_REQUEST',
  'content/GET_LEVELS_SUCCESS',
  'content/GET_LEVELS_FAILURE',
)<void, Option[], Error>();
